<template>
  <div id="notice" :style="{width:width}">
    <!-- 头部导航部分 -->
    <HomeHeader />
    <div style="height:70px;"></div>
    <!-- banner -->
    <div class="notice-top">
      <span class="topbar-back" @click="goback()">
        <i class="topbar-back-icon"></i>
        <span class="topbar-back-text">返回</span>
      </span>
      <span class="topbar-title">公告列表</span>
    </div>
    <!-- 内容 -->
    <div class="list_body">
      <ul>
        <li class="items" v-for="item in list" :key="item" @click="goNext(item.contentId)">
          <div class="item_title">
            <span class="red_dot" v-if="!item.isRead"></span>
            {{item.title}}
          </div>
          <div class="item_content" v-html="item.content"></div>
          <div class="item_bottom">
            <span>{{item.updateTime}}</span>
          </div>
        </li>
      </ul>
      <div class="noData" v-if="list.length === 0">暂无数据</div>
    </div>
    <!-- 底部组件 -->
    <HomeFooter style="margin-top: 78px;" :class="list.length > 3 ? '' : 'page_bottom'"></HomeFooter>
  </div>
</template>

<script>
import HomeHeader from '../../../components/HomeHeader'
import HomeFooter from '../../../components/HomeFooter'
import { getInformationList } from '@/api/modules/Information'
export default {
  name: 'Notice',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      pageNumber: '',
      defaultPage: 1,
      searchString: '',
      list: [],
      pageinfo: {},
      pageIndex: 1
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const obj = {
        groupId: '21811'
      }
      const res = await getInformationList(obj)
      if (res.code === 0) {
        var arr = JSON.parse(localStorage.getItem('NoticeArray'))
        if (arr === null) {
          arr = []
        }
        res.data.dataList.forEach(element => {
          element.updateTime = this.timestampToTime(element.updateTime)
          const indexNum = arr.indexOf(element.contentId)
          if (indexNum > -1) {
            element.isRead = true
          }
          else {
            element.isRead = false
          }
        })
        this.list = res.data.dataList
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
        return
      }
    },
    timestampToTime(timestamp) {
      const date = new Date(timestamp)
      var Y = date.getFullYear() + '年'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
      var D = date.getDate() + '日'
      // var h = date.getHours() + ':'
      // var m = date.getMinutes() + ':'
      // var s = date.getSeconds()
      return Y + M + D
    },
    goback() {
      this.$router.back()
    },
    goNext(id) {
      var arr = JSON.parse(localStorage.getItem('NoticeArray'))
      if (arr === null) {
        arr = []
      }
      arr.push(id)
      window.localStorage.setItem('NoticeArray', JSON.stringify(arr))
      this.$router.push({
        name: 'NoticeDetail',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
// top
.notice-top{
  width:1340px;
  margin:0 auto;
  background: #FFFFFF;
  border: 1px solid rgba(6, 15, 26, 0.07);
  border-radius: 6px;
  height: 64px;
  padding: 21px 24px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-top:60px;
  .topbar-back{
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;
    color: #10141A;
    cursor: pointer;
  }
  .topbar-back-icon{
    display: block;
    width: 12px;
    height: 20px;
    background-size: 12px 20px;
    background-image: url(../../../assets/img/home/leftArrow.png);
    margin-right: 6px;
    background-size: 100% 100%;
    width: 20px;
  }
  .topbar-title{
    border-left: 1px solid rgba(8, 16, 26, 0.25);
    padding-left: 24px;
    margin-left: 24px;
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;
    color: #10141A;
  }
}
// 内容
.list_body{
  width:1340px;
  margin:0 auto;
  border: 1px solid rgba(6, 15, 26, 0.07);
  border-radius: 6px;
  margin-top: 16px;
  overflow: hidden;
  background: #fff;
  ul{
    margin:0;
    padding:0;
  }
  ul li {
    list-style: none;
    transition: all .5s;
  }
  .items{
    border-top: 1px solid rgba(6, 15, 26, 0.07);
    padding:24px;
    .item_title{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 18px;
      line-height: 22px;
      margin-bottom: 12px;
      font-weight: 500;
      cursor: pointer;
    }
    .item_content{
      min-width: 448px;
      font-size: 14px;
      line-height: 22px;
      color: rgba(12, 18, 25, 0.7);
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .item_title:hover{
      color: #5D82FF;
      cursor:pointer;
    }
    .item_bottom{
      margin-top:12px;
      color: rgba(11, 18, 26, 0.6);
    }
  }
  ul li:nth-child(1){
    border:none;
  }
}
.noData{
  text-align: center;
  padding: 70px 0;
  line-height: 50px;
  font-size: 24px;
  color:#DDD;
}
.page_bottom{
  position:fixed;
  bottom:0;
  width: 100%;
}
.red_dot{
  display: inline-block;
  width:6px;
  height:6px;
  border-radius: 6px;
  background: red;
  margin: 0 5px;
}
</style>
